import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getInitialLanguage } from '../Utils/getInitialLanguage';

// Recursos de tradução
const resources = {
  "pt-BR": {
    translation: {
      welcome: "Seja bem-vindo!",
      loginSubtitle: "Digite seu login e senha para acessar o Playmove Class e o Playmove Academia",
      email: "Email",
      password: "Senha",
      rememberMe: "Lembrar de mim",
      forgotPassword: "Esqueci minha senha",
      loginButton: "Entrar",
      invalidLoginError: "Login ou senha inválidos",
      genericLoginError: "Ocorreu um erro no login.",
      signingIn: "Entrando...",
      headerAlt: "Cabeçalho",
      footerAlt: "Playmove",
      academiaAlt: "Playmove Academia",
      classAlt: "Playmove Class",
      academiaCardDescription: "Entre e faça a sua formação, com certificado Playmove",
      classCardDescription: "Acesse os relatórios de desempenho, configure seus alunos, crie turmas e muito mais",
      accessButton: "ACESSAR",
      createPasswordTitle: "Crie sua senha",
      createPasswordSubtitle: "A nova senha deve conter no mínimo 6 caracteres e pelo menos uma letra e um número",
      passwordLabel: "Digite a senha",
      passwordAgainLabel: "Digite a senha novamente",
      resetLinkExpired: "Link para redefinir senha expirou.",
      resetLinkExpiredShort: "Esta redefinição de senha expirou!",
      passwordMinLength: "A senha precisa ter pelo menos 6 caracteres.",
      passwordMustContainLetterAndNumber: "A senha precisa ter pelo menos uma letra e um número.",
      passwordsNotMatch: "As senhas digitadas não coincidem.",
      errorResettingPassword: "Ocorreu um erro ao redefinir a senha.",
      sending: "Enviando...",
      confirm: "Confirmar",
      confirmModalTitle: "Confirmação",
      currentFlagAlt: "Bandeira atual",
      dropdownAlt: "Abrir seleção",
      forgotPasswordModalTitle: "Esqueci minha senha",
      forgotPasswordModalDescription: "Para redefinir sua senha, insira o e-mail associado à sua conta",
      forgotPasswordEmailLabel: "E-mail",
      forgotPasswordEmailPlaceholder: "seu e-mail",
      forgotPasswordInvalidEmail: "Email inválido!",
      forgotPasswordSuccess: "Solicitação enviada com sucesso",
      forgotPasswordError: "Endereço de e-mail inválido ou inexistente!",
      updatePasswordTitle: "Atualize sua senha",
      updatePasswordSubtitle: "No primeiro acesso, você precisa criar uma nova senha.",
      newPasswordLabel: "Nova senha",
      confirmNewPasswordLabel: "Confirme a nova senha",
      updatePasswordErrorRegex: "A senha nova deve conter no mínimo 6 caracteres, uma letra e um número.",
      updatePasswordErrorConfirmation: "As senhas não coincidem!",
      updatePasswordButtonLoading: "Atualizando...",
      updatePasswordButtonConfirm: "Confirmar",
      courses: "Cursos",
      coursesDescription: "Acesse os cursos e se prepare para transformar a educação.",
      audienceBoth: "Todos",
      audienceMasters: "Masters",
      audienceProfessors: "Professores",
      audienceUnknown: "Público indefinido",
      experienceEarlyChildhood: "Educação Infantil",
      experienceSpecialEducation: "Educação Especial",
      experienceUnknown: "Experiência indefinida",
      languagePortuguese: "Português",
      languageEnglish: "Inglês",
      registrations: "Cadastros",
      registrationsDescription: "Cadastre seus professores, turmas e escolas.",
      registrationsPage: {
        sections: {
          schools: { title: "Escolas", tabLabel: "escolas" },
          classes: { title: "Turmas", tabLabel: "turmas" },
          students: { title: "Alunos", tabLabel: "alunos" }
        },
        fields: {
          name: "Nome",
          email: "E-mail",
          country: "País",
          state: "Estado",
          stateShort: "UF",
          city: "Cidade",
          school: "Escola",
          class: "Turma",
          student: "Aluno",
          studentsList: "Lista de alunos",
          course: "Curso",
          trail: "Trilha"
        },
        filters: {
          searchSchools: "Buscar por nome de escola...",
          searchClasses: "Buscar por nome de turma...",
          searchStudents: "Buscar por nome de aluno...",
          searchCourses: "Buscar por título...",
          byCountry: "Filtrar por país",
          byState: "Filtrar por estado",
          byCity: "Filtrar por cidade",
          bySchool: "Filtrar por escola",
          byClass: "Filtrar por turma"
        },
        placeholders: {
          country: "País",
          state: "UF",
          city: "cidade",
          school: "escola",
          class: "turma",
          selectCountry: "Selecione um país",
          selectState: "Selecione um estado",
          selectCity: "Selecione uma cidade",
          selectCityWithSchools: "Selecione uma cidade com escolas",
          selectSchool: "Selecione uma escola"
        },
        actions: {
          addSchool: "add escola",
          addClass: "add turma",
          addStudent: "add aluno",
          addStudentList: "add lista alunos",
          addCourses: "Adicionar Cursos",
          importStudents: "Importar Lista de Alunos",
          add: "adicionar",
          edit: "editar",
          delete: "excluir"
        },
        confirmations: {
          deleteSchool: "Tem certeza que deseja excluir a escola '{{name}}'?",
          deleteClass: "Tem certeza que deseja excluir a turma '{{name}}'?",
          deleteStudent: "Tem certeza que deseja excluir o aluno '{{name}}'?"
        },
        success: {
          schoolDeleted: "Escola excluída com sucesso",
          classDeleted: "Turma excluída com sucesso",
          studentDeleted: "Aluno excluído com sucesso",
          schoolCreated: "Escola criada com sucesso",
          schoolUpdated: "Escola atualizada com sucesso",
          classCreated: "Turma criada com sucesso!",
          classUpdated: "Turma atualizada com sucesso!",
          studentCreated: "Aluno criado com sucesso",
          studentUpdated: "Aluno atualizado com sucesso",
          studentsListCreated: "Lista de alunos criada com sucesso"
        },
        validation: {
          requiredField: "O campo {{field}} é obrigatório",
          invalidEmail: "O e-mail não é válido",
          fileRequired: "Por favor, selecione um arquivo para importar.",
          csvOnly: "O arquivo deve estar no formato .csv"
        },
        tables: {
          schools: {
            columns: {
              id: "Id",
              name: "Escola",
              country: "País",
              state: "UF",
              city: "Cidade",
              classes: "Turmas"
            },
            classCount_one: "{{count}} turma",
            classCount_other: "{{count}} turmas"
          },
          classes: {
            columns: {
              id: "Id",
              name: "Turma",
              school: "Escola",
              country: "País",
              state: "UF",
              city: "Cidade",
              studentsCourses: "Alunos/Cursos"
            },
            studentsCount_one: "{{count}} aluno",
            studentsCount_other: "{{count}} alunos",
            coursesCount_one: "{{count}} curso",
            coursesCount_other: "{{count}} cursos"
          },
          students: {
            columns: {
              id: "Id",
              name: "Aluno",
              class: "Turma",
              school: "Escola",
              country: "País",
              state: "UF",
              city: "Cidade",
              email: "E-mail"
            }
          },
          classCourses: {
            columns: {
              type: "Tipo",
              title: "Título",
              modulesCourses: "Módulos/Cursos",
              duration: "Duração"
            },
            moduleCount_one: "{{count}} módulo",
            moduleCount_other: "{{count}} módulos",
            courseCount_one: "{{count}} curso",
            courseCount_other: "{{count}} cursos",
            durationHours: "{{hours}} hora(s)"
          }
        },
        forms: {
          school: {
            titleCreate: "Criar Escola",
            titleEdit: "Editar Escola",
            placeholders: {
              name: "nome da escola"
            }
          },
          student: {
            titleCreate: "Criar Aluno",
            titleEdit: "Editar Aluno",
            placeholders: {
              name: "nome completo do aluno",
              email: "e-mail do aluno"
            },
            passwordInfo: "A senha será enviada por e-mail ao aluno."
          },
          studentList: {
            title: "Importar Lista de Alunos",
            passwordInfo: "A senha será enviada por e-mail aos alunos da lista.",
            selectFile: "Selecionar arquivo",
            selectedFile: "Arquivo selecionado: {{name}}",
            noFileSelected: "Nenhum arquivo selecionado",
            sampleButton: "Modelo Exemplo",
            sampleFileName: "exemplo.csv",
            sampleHeader: "Nome;Email;Código país;UF;Cidade;Escola;Turma",
            sampleRow: "João da Silva;professor@gmail.com;BR;SC;Blumenau;Escola Municipal Centro;Turma 5A"
          },
          classForm: {
            editingLabel: "Edição",
            creatingLabel: "Nova",
            heading: "Turma",
            placeholders: {
              name: "nome da turma"
            },
            coursesAvailableSection: "Cursos disponíveis para essa turma",
            addCoursesSection: "Adicionar Cursos"
          }
        }
      },
      ourCourses: "Nossos cursos",
      all: "Todos",
      inProgress: "Em andamento",
      completed: "Concluídos",
      favourites: "Favoritos",
      searchByTitle: "Buscar por título...",
      noRecordsFound: "Nenhum registro encontrado",
      reports: "Relatórios",
      signOut: "Sair",
      editProfile: "Editar cadastro",
      name: "Nome",
      yourName: "seu nome",
      yourEmail: "seu e-mail",
      clickToEditPhoto: "Clique na foto para editar",
      passwordUpdated: "Senha atualizada com sucesso!",
      updateSuccess: "Dados atualizados com sucesso!",
      emailInUse: "Este e-mail já está sendo utilizado!",
      updateFail: "Não foi possível atualizar seu cadastro. Tente novamente mais tarde",
      nameEmailRequired: "Os campos nome e e-mail não podem ser vazios",
      changePasswordButton: "alterar senha",
      changePassword: "Alterar senha",
      currentPassword: "Senha atual",
      yourCurrentPassword: "sua senha atual",
      newPassword: "Nova senha",
      yourNewPassword: "sua nova senha",
      confirmNewPassword: "Confirmar nova senha",
      confirmYourNewPassword: "confirme sua nova senha",
      newPasswordRegexError: "A senha deve ter no mínimo 6 caracteres e conter letras e números",
      passwordMismatch: "As senhas não conferem",
      newPasswordSameAsOld: "A nova senha deve ser diferente da atual",
      invalidPassword: "Senha inválida!",
      save: "salvar",
      cancelButton: "cancelar",
      courseTitle: "Curso",
      aboutCourse: "Sobre o curso",
      modules: "Módulos:",
      duration: "Duração:",
      hours: "hora (s)",
      materials: "Materiais",
      download: "Fazer download",
      start: "Iniciar",
      continue: "Continuar",
      continueReviewing: "Continuar revendo",
      reviewCourse: "Rever curso",
      courseCompletedProgress: "% do curso concluído",
      rateModuleTitle: "O que você achou desse módulo?",
      poor: "Ruim",
      average: "Médio",
      likeIt: "Gostei",
      backToCourse: "Voltar ao curso",
      congratulations: "Parabéns!",
      youCompletedCourse: "Você concluiu nosso curso.",
      courseCompletionCaLine1: "Parabéns!",
      courseCompletionCaLine2: "Você concluiu a visão geral Playmove.",
      courseCompletionCaLine3: "Estamos empolgados por tê-lo explorando o Ecossistema Playmove como parte da sua experiência em sala de aula.",
      rateThisCourse: "Avalie este curso:",
      rateAndGetCertificate: "Avalie nosso curso e, em seguida, receba seu certificado.",
      selectEachCategory: "Selecione sua nota para cada categoria abaixo:",
      categoryEasyAccess: "As vídeoaulas gravadas são de fácil acesso.",
      categoryGoodQuality: "As vídeoaulas possuem boa qualidade de imagem e áudio.",
      categoryEasyToUse: "Existe facilidade no manuseio da ferramenta EAD.",
      categoryClearThemes: "Os temas abordados são claros e objetivos.",
      categoryInstructorMastery: "O domínio do assunto pelo orientador é demonstrado nas vídeoaulas.",
      categoryWillApplyKnowledge: "Aplicarei o conhecimento no meu planejamento escolar.",
      leaveAComment: "Deixe aqui um comentário",
      thankYouForRating: "Obrigado pela sua avaliação!",
      bad: "Péssimo",
      good: "Bom",
      veryGood: "Muito bom",
      certificateHeader: "Certificamos que",
      certificateParticipated: "participou {{courseOrTrail}}",
      ofCourse: "do curso",
      ofLearningPath: "da trilha de aprendizado",
      certificateWithProgram: "com programação de",
      hoursOfActivities: "hora (s) de atividades.",
      cityAndDate: "{{city}}, {{date}}",
      certificateGeneratedOn: "Certificado gerado em:",
      generatingCertificate: "Gerando certificado...",
      downloadCertificate: "Baixar certificado",
      send: "enviar",
      reviewTrail: "Rever trilha",
      coursesInThisTrail: "Cursos desta trilha:",
      aboutThisTrail: "Sobre esta trilha",
      trail: "Trilha",
      trailCompletedPercent: "% da trilha concluída",
      courseInTrail: "Curso {{n}}: {{courseTitle}}",
      backToTrail: "Voltar à trilha",
      youCompletedTrail: "Você concluiu nossa trilha.",
      rateThisTrail: "Avalie esta trilha:",
      rateAndGetCertificateTrail: "Avalie nossa trilha e, em seguida, receba seu certificado.",
      thankYouForRatingTrail: "Obrigado pela sua avaliação!",
      certificateFileName: "Certificado - {{title}}",
    }
  },
  "en-CA": {
    translation: {
      welcome: "Welcome!",
      loginSubtitle: "Enter your login and password to access Playmove Analytics and Playmove Learning",
      email: "Email",
      password: "Password",
      rememberMe: "Remember me",
      forgotPassword: "Forgot my password",
      loginButton: "Sign In",
      invalidLoginError: "Invalid login or password",
      genericLoginError: "An error occurred while logging in.",
      signingIn: "Signing in...",
      headerAlt: "Header",
      footerAlt: "Playmove",
      academiaAlt: "Playmove Academia",
      classAlt: "Playmove Analytics",
      academiaCardDescription: "Log in and complete your training, with a Playmove certificate",
      classCardDescription: "Access performance reports, manage your students, create classes and much more",
      accessButton: "ACCESS",
      createPasswordTitle: "Create your password",
      createPasswordSubtitle: "The new password must have at least 6 characters and contain at least one letter and one number",
      passwordLabel: "Enter your password",
      passwordAgainLabel: "Re-enter your password",
      resetLinkExpired: "Password reset link expired.",
      resetLinkExpiredShort: "This password reset has expired!",
      passwordMinLength: "Password must be at least 6 characters long.",
      passwordMustContainLetterAndNumber: "Password must contain at least one letter and one number.",
      passwordsNotMatch: "The passwords do not match.",
      errorResettingPassword: "An error occurred while resetting the password.",
      sending: "Sending...",
      confirm: "Confirm",
      confirmModalTitle: "Confirmation",
      currentFlagAlt: "Current flag",
      dropdownAlt: "Open selection",
      forgotPasswordModalTitle: "Forgot my password",
      forgotPasswordModalDescription: "To reset your password, please enter the email associated with your account",
      forgotPasswordEmailLabel: "Email",
      forgotPasswordEmailPlaceholder: "your email",
      forgotPasswordInvalidEmail: "Invalid email!",
      forgotPasswordSuccess: "Request sent successfully",
      forgotPasswordError: "Invalid or non-existent email address!",
      updatePasswordTitle: "Update your password",
      updatePasswordSubtitle: "On first access, you need to create a new password.",
      newPasswordLabel: "New password",
      confirmNewPasswordLabel: "Confirm new password",
      updatePasswordErrorRegex: "The new password must have at least 6 characters, including at least one letter and one number.",
      updatePasswordErrorConfirmation: "The passwords do not match!",
      updatePasswordButtonLoading: "Updating...",
      updatePasswordButtonConfirm: "Confirm",
      courses: "Courses",
      coursesDescription: "Access the courses and prepare to transform education",
      audienceBoth: "All",
      audienceMasters: "Masters",
      audienceProfessors: "Teachers",
      audienceUnknown: "Unknown audience",
      experienceEarlyChildhood: "Early Childhood",
      experienceSpecialEducation: "Special Education",
      experienceUnknown: "Unknown experience",
      languagePortuguese: "Portuguese",
      languageEnglish: "English",
      registrations: "Registrations",
      registrationsDescription: "Register your teachers, classes, and schools.",
      registrationsPage: {
        sections: {
          schools: { title: "Schools", tabLabel: "schools" },
          classes: { title: "Classes", tabLabel: "classes" },
          students: { title: "Students", tabLabel: "students" }
        },
        fields: {
          name: "Name",
          email: "Email",
          country: "Country",
          state: "State",
          stateShort: "State",
          city: "City",
          school: "School",
          class: "Class",
          student: "Student",
          studentsList: "Student list",
          course: "Course",
          trail: "Learning path"
        },
        filters: {
          searchSchools: "Search by school name...",
          searchClasses: "Search by class name...",
          searchStudents: "Search by student name...",
          searchCourses: "Search by title...",
          byCountry: "Filter by country",
          byState: "Filter by state",
          byCity: "Filter by city",
          bySchool: "Filter by school",
          byClass: "Filter by class"
        },
        placeholders: {
          country: "Country",
          state: "State",
          city: "city",
          school: "school",
          class: "class",
          selectCountry: "Select a country",
          selectState: "Select a state",
          selectCity: "Select a city",
          selectCityWithSchools: "Select a city with schools",
          selectSchool: "Select a school"
        },
        actions: {
          addSchool: "add school",
          addClass: "add class",
          addStudent: "add student",
          addStudentList: "add student list",
          addCourses: "Add Courses",
          importStudents: "Import Student List",
          add: "add",
          edit: "edit",
          delete: "delete"
        },
        confirmations: {
          deleteSchool: "Are you sure you want to delete the school '{{name}}'?",
          deleteClass: "Are you sure you want to delete the class '{{name}}'?",
          deleteStudent: "Are you sure you want to delete the student '{{name}}'?"
        },
        success: {
          schoolDeleted: "School deleted successfully",
          classDeleted: "Class deleted successfully",
          studentDeleted: "Student deleted successfully",
          schoolCreated: "School created successfully",
          schoolUpdated: "School updated successfully",
          classCreated: "Class created successfully!",
          classUpdated: "Class updated successfully!",
          studentCreated: "Student created successfully",
          studentUpdated: "Student updated successfully",
          studentsListCreated: "Student list created successfully"
        },
        validation: {
          requiredField: "The {{field}} field is required",
          invalidEmail: "The email is not valid",
          fileRequired: "Please select a file to import.",
          csvOnly: "The file must be in .csv format"
        },
        tables: {
          schools: {
            columns: {
              id: "Id",
              name: "School",
              country: "Country",
              state: "State",
              city: "City",
              classes: "Classes"
            },
            classCount_one: "{{count}} class",
            classCount_other: "{{count}} classes"
          },
          classes: {
            columns: {
              id: "Id",
              name: "Class",
              school: "School",
              country: "Country",
              state: "State",
              city: "City",
              studentsCourses: "Students/Courses"
            },
            studentsCount_one: "{{count}} student",
            studentsCount_other: "{{count}} students",
            coursesCount_one: "{{count}} course",
            coursesCount_other: "{{count}} courses"
          },
          students: {
            columns: {
              id: "Id",
              name: "Student",
              class: "Class",
              school: "School",
              country: "Country",
              state: "State",
              city: "City",
              email: "Email"
            }
          },
          classCourses: {
            columns: {
              type: "Type",
              title: "Title",
              modulesCourses: "Modules/Courses",
              duration: "Duration"
            },
            moduleCount_one: "{{count}} module",
            moduleCount_other: "{{count}} modules",
            courseCount_one: "{{count}} course",
            courseCount_other: "{{count}} courses",
            durationHours: "{{hours}} hour(s)"
          }
        },
        forms: {
          school: {
            titleCreate: "Create School",
            titleEdit: "Edit School",
            placeholders: {
              name: "school name"
            }
          },
          student: {
            titleCreate: "Create Student",
            titleEdit: "Edit Student",
            placeholders: {
              name: "student full name",
              email: "student email"
            },
            passwordInfo: "The password will be sent to the student by email."
          },
          studentList: {
            title: "Import Student List",
            passwordInfo: "Passwords will be sent by email to every student in the list.",
            selectFile: "Select file",
            selectedFile: "Selected file: {{name}}",
            noFileSelected: "No file selected",
            sampleButton: "Sample File",
            sampleFileName: "example.csv",
            sampleHeader: "Name;Email;Country code;State;City;School;Class",
            sampleRow: "John Smith;teacher@email.com;CA;ON;Toronto;Central School;Class 5A"
          },
          classForm: {
            editingLabel: "Editing",
            creatingLabel: "New",
            heading: "Class",
            placeholders: {
              name: "class name"
            },
            coursesAvailableSection: "Courses available for this class",
            addCoursesSection: "Add Courses"
          }
        }
      },
      ourCourses: "Our courses",
      all: "All",
      inProgress: "In progress",
      completed: "Completed",
      favourites: "Favorites",
      searchByTitle: "Search by title...",
      noRecordsFound: "No records found",
      reports: "Reports",
      signOut: "Sign out",
      editProfile: "Edit profile",
      name: "Name",
      yourName: "your name",
      yourEmail: "your email",
      clickToEditPhoto: "Click the photo to edit",
      passwordUpdated: "Password updated successfully!",
      updateSuccess: "Data updated successfully!",
      emailInUse: "This email is already in use!",
      updateFail: "Could not update your profile. Please try again later",
      nameEmailRequired: "Name and email fields cannot be empty",
      changePasswordButton: "change password",
      changePassword: "Change password",
      currentPassword: "Current password",
      yourCurrentPassword: "your current password",
      newPassword: "New password",
      yourNewPassword: "your new password",
      confirmNewPassword: "Confirm new password",
      confirmYourNewPassword: "confirm your new password",
      newPasswordRegexError: "Password must be at least 6 characters and contain letters and numbers",
      passwordMismatch: "Passwords do not match",
      newPasswordSameAsOld: "New password must be different from the current one",
      invalidPassword: "Invalid password!",
      save: "save",
      cancelButton: "cancel",
      courseTitle: "Course",
      aboutCourse: "About the course",
      modules: "Modules:",
      duration: "Duration:",
      hours: "hour(s)",
      materials: "Materials",
      download: "Download",
      start: "Start",
      continue: "Continue",
      continueReviewing: "Continue reviewing",
      reviewCourse: "Review course",
      courseCompletedProgress: "% of the course completed",
      rateModuleTitle: "What did you think of this module?",
      poor: "Poor",
      average: "Average",
      likeIt: "Liked it",
      backToCourse: "Back to the course",
      congratulations: "Congratulations!",
      youCompletedCourse: "You've completed our course.",
      courseCompletionCaLine1: "Congratulations!",
      courseCompletionCaLine2: "You have completed the Playmove Overview.",
      courseCompletionCaLine3: "We're excited to have you exploring the Playmove Ecosystem as part of your classroom experience.",
      rateThisCourse: "Rate this course:",
      rateAndGetCertificate: "Please rate our course and then receive your certificate.",
      selectEachCategory: "Please rate each category below:",
      categoryEasyAccess: "The recorded video lessons are easy to access.",
      categoryGoodQuality: "The video lessons have good image and audio quality.",
      categoryEasyToUse: "The platform is easy to navigate.",
      categoryClearThemes: "The topics covered are clear and straightforward.",
      categoryInstructorMastery: "The instructor demonstrates mastery of the content in the lessons.",
      categoryWillApplyKnowledge: "I will apply what I learned in my lesson planning.",
      leaveAComment: "Leave a comment",
      thankYouForRating: "Thank you for your feedback!",
      bad: "Bad",
      good: "Good",
      veryGood: "Excellent",
      certificateHeader: "This certifies that",
      certificateParticipated: "has successfully completed the {{courseOrTrail}}",
      ofCourse: "course",
      ofLearningPath: "trail",
      certificateWithProgram: "with a total of",
      hoursOfActivities: "hour(s) of activities.",
      cityAndDate: "{{city}}, {{date}}",
      certificateGeneratedOn: "Certificate generated on:",
      generatingCertificate: "Generating certificate...",
      downloadCertificate: "Download certificate",
      send: "send",
      reviewTrail: "Review trail",
      coursesInThisTrail: "Courses in this trail:",
      aboutThisTrail: "About this trail",
      trail: "Trail",
      trailCompletedPercent: "% of the trail completed",
      courseInTrail: "Course {{n}}: {{courseTitle}}",
      backToTrail: "Back to trail",
      youCompletedTrail: "You've completed our trail.",
      rateThisTrail: "Rate this trail:",
      rateAndGetCertificateTrail: "Please rate our trail and then receive your certificate.",
      thankYouForRatingTrail: "Thank you for your feedback!",
      certificateFileName: "Certificate - {{title}}",
    }
  }
};

const initialLanguage = getInitialLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage, // idioma padrão de acordo com a configuração
    fallbackLng: initialLanguage || "pt-BR",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
